import React, { Suspense } from "react";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";

import { Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { Permissions } from "../../../util/Permissions";
import { UserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/UserGroupMenu";
import { Section } from "../../Common/layout/Section";
import { SecurityQuestions } from "./SecurityQuestions";


const SecurityQuestionPages = () => {
    return <>
        <AsideMenu>
            <UserGroupMenu destination="/security-questions" />
        </AsideMenu>
        <Section>
            <Suspense fallback={<LayoutSplashScreen />}>
                <Switch>
                    <ContentRoute path="/security-questions/:userGroup" permission={Permissions.SECURITY_QUESTIONS} component={SecurityQuestions} />
                </Switch>
            </Suspense>
        </Section>
    </>
};

export default SecurityQuestionPages;
